import { render, staticRenderFns } from "./ClassifiedCardRemarkEditDialog.vue?vue&type=template&id=2a0d4da2&lang=pug"
import script from "./ClassifiedCardRemarkEditDialog.vue?vue&type=script&lang=js"
export * from "./ClassifiedCardRemarkEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports